module.exports = __webpack_public_path__ + "static/img/install_to_wework.fd71440.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/install_to_wework.png
// module id = 0iRl
// module chunks = 1